module.exports = __webpack_public_path__ + "media/images/themes/mandy/6 (copy)-b1224b1aa828d7eb8309b36e328a8124.jpg";